import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, Theme, StyledEngineProvider, CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { LocaleManager } from 'helpers/Locale';

import 'react-quill/dist/quill.snow.css'; // ES6

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { LicenseInfo } from '@mui/x-license-pro';

import theme from 'assets';
import { MyIntlProvider, Routes } from 'components';

import { ApplicationUserProvider, AxiosInterceptors } from 'helpers/services';
import 'helpers/Extensions';

LicenseInfo.setLicenseKey('b6ebaee9a3fd555a2891ada02f03e379Tz00MzcxMCxFPTE2ODQwNzc4MDEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme { }
// }

let App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <LocaleManager>
            <SnackbarProvider preventDuplicate>
              <CssBaseline />
              <ApplicationUserProvider>
                <Router basename="/app">
                  <MyIntlProvider>
                    <AxiosInterceptors />
                    <Routes />
                  </MyIntlProvider>
                </Router>
              </ApplicationUserProvider>
            </SnackbarProvider>
          </LocaleManager>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
